<!-- SWITCH -->
<ridango-navigation-bar [showOnMobile]="true">
    <ul>
        <li>
            <a
                [routerLink]="'/my-account' | localize"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: false }">
                {{ 'TRAVELCARD_SEARCH_TAB' | translate }}
            </a>
        </li>

        <li>
            <a
                [routerLink]="'/my-account/bankcard-tickets' | localize"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: false }">
                {{ 'BANKCARD_SEARCH_TAB' | translate }}
            </a>
        </li>
    </ul>
</ridango-navigation-bar>

<router-outlet></router-outlet>
